import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { paymentService } from '../services/paymentService';
import { orderService } from '../services/orderService';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const PaymentSuccess = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [verifying, setVerifying] = useState(true);
  const [paymentStatus, setPaymentStatus] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const sessionId = searchParams.get('session_id');
    if (sessionId) {
      verifyPayment(sessionId);
    } else {
      setError('Aucun identifiant de session trouvé');
      setVerifying(false);
    }
  }, [searchParams]);

  const verifyPayment = async (sessionId) => {
    try {
      const result = await paymentService.verifyStripePayment(sessionId);
      if (result.success) {
        setPaymentStatus(result.paid ? 'success' : 'pending');
        // Rafraîchir la commande pour obtenir les dernières informations
        if (result.orderId) {
          // La commande sera automatiquement mise à jour par le webhook
          // On peut juste attendre un peu et rediriger
          setTimeout(() => {
            navigate('/dashboard');
          }, 3000);
        }
      } else {
        setError(result.error || 'Erreur lors de la vérification du paiement');
        setPaymentStatus('error');
      }
    } catch (err) {
      console.error('Erreur lors de la vérification:', err);
      setError('Une erreur est survenue');
      setPaymentStatus('error');
    } finally {
      setVerifying(false);
    }
  };

  return (
    <div>
      <Navbar />

      <div className="container">
        <div style={{ maxWidth: '600px', margin: '0 auto', textAlign: 'center', padding: '40px 20px' }}>
          {verifying ? (
            <>
              <div style={{ fontSize: '60px', marginBottom: '20px' }}>⏳</div>
              <h1 style={{ marginBottom: '15px' }}>Vérification du paiement...</h1>
              <p style={{ color: '#666' }}>Veuillez patienter pendant que nous vérifions votre paiement.</p>
            </>
          ) : paymentStatus === 'success' ? (
            <>
              <div style={{ fontSize: '60px', marginBottom: '20px' }}>✅</div>
              <h1 style={{ marginBottom: '15px', color: '#28a745' }}>Paiement réussi !</h1>
              <p style={{ color: '#666', marginBottom: '30px' }}>
                Votre paiement a été traité avec succès. Votre commande est maintenant en cours de traitement.
              </p>
              <button
                className="btn btn-primary"
                onClick={() => navigate('/dashboard')}
              >
                Voir mes commandes
              </button>
              <p style={{ marginTop: '20px', color: '#999', fontSize: '14px' }}>
                Redirection automatique dans quelques secondes...
              </p>
            </>
          ) : paymentStatus === 'pending' ? (
            <>
              <div style={{ fontSize: '60px', marginBottom: '20px' }}>⏳</div>
              <h1 style={{ marginBottom: '15px', color: '#ffc107' }}>Paiement en attente</h1>
              <p style={{ color: '#666', marginBottom: '30px' }}>
                Votre paiement est en cours de traitement. Vous recevrez une confirmation par email une fois le paiement confirmé.
              </p>
              <button
                className="btn btn-primary"
                onClick={() => navigate('/dashboard')}
              >
                Retour au dashboard
              </button>
            </>
          ) : (
            <>
              <div style={{ fontSize: '60px', marginBottom: '20px' }}>❌</div>
              <h1 style={{ marginBottom: '15px', color: '#dc3545' }}>Erreur de paiement</h1>
              <p style={{ color: '#666', marginBottom: '30px' }}>
                {error || 'Une erreur est survenue lors du traitement de votre paiement.'}
              </p>
              <button
                className="btn btn-primary"
                onClick={() => navigate('/dashboard')}
              >
                Retour au dashboard
              </button>
            </>
          )}
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default PaymentSuccess;

